import mrpStyles from './../mrp.json'

export default {
  color: mrpStyles.colors.PrimaryBlack,
  inverseColor: mrpStyles.colors.PrimaryWhite,
  paragraphFontStyle: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '21px',
    color: mrpStyles.colors.PrimaryBlack
  }
}
